<template lang="html">
	<div class="registration">
		<HeadModule :openTarget="'native/current'"/>
		<div class="reg_module">
			<div class="reg_numPhone">
				<input type="text" name="" value="" placeholder="请输入您的手机号" v-model="phone">
			</div>
			<div class="reg_verificationCode">
				<input type="text" name="" value="" placeholder="验证码" v-model="sms_code">
				<div type="button" name="button" @click="cellPhone()"> {{content}} </div>
			</div>
			<div class="reg_email">
				<input type="email" name="" value="" placeholder="请输入您的邮箱" v-model="Email">
			</div>
			<div class="reg_useName">
				<input type="text" name="" value="" placeholder="设置用户名/不可更改" v-model='userName'>
			</div>
			<div class="reg_password">
				<input type="text" name="" value="" placeholder="输入6-18位包含大小写及数字的密码" v-model='password'>
			</div>
			<div class="reg_lest">
				<div class="btn_return" @click="btnReturn">
					返回
				</div>
				<div class="btn_later" @click="later()">
					下一步
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '@/utils/utils.js';
	import HeadModule from '@/components/HeadModule'

	export default {
		data() {
			return {
				phone: '',
				sms_code: '',
				Email: '',
				userName: '',
				password: '',
				totalTime: 60,
				content: '发送验证码',
			}
		},
		components: {
			HeadModule: HeadModule,
		},
		methods: {
			later() {
				if (/^1[3|4|5|6|7|8]\d{9}$/.test(this.phone)) {
					if (this.sms_code != '') {
						if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.Email)) {
							if (this.userName != '') {
								if (/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,18}$/.test(this.password)) {
									this.$http({
										url: '/Registered/registered',
										method: 'get',
										params: {
											phone_head: 86,
											phone: this.phone,
											sms_code: this.sms_code,
											email: this.Email,
											username: this.userName,
											password: this.password,
										}
									}).then((res) => {
										if (res.code == '0') {
											localStorage.setItem('uid', res.data.uid);
											localStorage.setItem('token', res.data.token);
											this.$router.push({
												path: '/activity',
												query: {
													id: this.$route.query.id,
												}
											})
										} else {
											utils.showMessage(res.msg)
										}
									})
								} else {
									utils.showMessage('密码格式错误')
								}
							} else {
								utils.showMessage('用户名入有误')
							}
						} else {
							utils.showMessage('邮箱格式错误')
						}
					} else {
						utils.showMessage('验证码输入有误')
					}
				} else {
					utils.showMessage('手机号输入有误')
				}
			},
			cellPhone() {
				if (this.phone == '') {
					utils.showMessage('手机号输入有误')
				} else {
					this.$http({
						url: '/Registered/getPhoneSmsCode',
						method: 'get',
						params: utils.cso({
							phone: this.phone,
							phone_head: 86,
							type: 1,
							client: 'H5'
						})
					}).then((res) => {
						if (res.code == 0) {
							this.content = this.totalTime + 's后重新发送'
							let clock = window.setInterval(() => {
								this.totalTime--
								this.content = this.totalTime + 's后重新发送'
								if (this.totalTime < 0) {
									window.clearInterval(clock)
									this.content = '发送验证码'
									this.totalTime = 60
								}
							}, 1000)
						} else {
							utils.showMessage(res.msg);
						}
					})
				}
			},
			btnReturn() {
				this.$router.push({
					path: '/login',
					query: {
						id: this.$route.query.id,
					}
				});
			}
		}
	}
</script>

<style lang="css" scoped>
	.reg_module {
		padding: 30px;
	}

	.reg_numPhone {
		padding: 10px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.reg_numPhone input {
		box-sizing: border-box;
		padding-left: 5px;
		width: 100%;
		background-color: #eeeeee;
		border: none;
		height: 40px;
	}

	.reg_verificationCode {
		padding: 10px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.reg_verificationCode input {
		box-sizing: border-box;
		padding-left: 5px;
		background-color: #eeeeee;
		border: none;
		height: 40px;
	}

	.reg_verificationCode div {
		text-align: center;
		width: 130px;
		height: 25px;
		line-height: 25px;
		font-size: 12px;
		border: 1px solid #E50101;
		border-radius: 10px;
		color: #E50101;
	}

	.reg_email {
		padding: 10px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.reg_email input {
		box-sizing: border-box;
		padding-left: 5px;
		width: 100%;
		background-color: #eeeeee;
		border: none;
		height: 40px;
	}

	.reg_useName {
		padding: 10px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.reg_useName input {
		box-sizing: border-box;
		padding-left: 5px;
		width: 100%;
		background-color: #eeeeee;
		border: none;
		height: 40px;
	}

	.reg_password {
		padding: 10px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.reg_password input {
		box-sizing: border-box;
		padding-left: 5px;
		width: 100%;
		background-color: #eeeeee;
		border: none;
		height: 40px;
	}

	.reg_lest {
		display: flex;
		justify-content: space-between;
		margin-top: 30px;
	}

	.btn_return {
		background-color: #F2F3F6;
		text-align: center;
		width: 150px;
		height: 45px;
		line-height: 45px;
		color: #606972;
		font-size: 18px;
		border-radius: 22.5px;
	}

	.btn_later {
		background: linear-gradient(to right, #FE405A, #E50101);
		text-align: center;
		width: 150px;
		height: 45px;
		line-height: 45px;
		color: #ffffff;
		font-size: 18px;
		border-radius: 22.5px;
	}
</style>
